import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/Frame.png';
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { class: "anchor-bottom" };
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalisationFinishPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getQuestionnaireByKey } = useQuizApi();
        function startSurvey() {
            getQuestionnaireByKey('OB_FINAN', (q) => {
                console.log(q, 'Found this questionnaire');
                router.push({ path: '/Questionnaire/' + q.id, query: { theme: 'dark', allowBack: 'false' } });
            });
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                        class: "heroImg",
                        src: _imports_0
                    }, null, -1)),
                    _cache[1] || (_cache[1] = _createElementVNode("h1", null, "The first step in your financial journey", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Taking control and organising your finances can be daunting, but it's a great first step towards financial stability.", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("p", null, null, -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(MGButton, {
                            alt: true,
                            text: "continue",
                            arrow: true,
                            onClick: startSurvey
                        })
                    ])
                ])
            ], 64));
        };
    }
});
